export const otpValidationStatus = {
  INCORRECT_OTP: "INCORRECT_OTP",
  EXPIRED_OTP: "EXPIRED_OTP",
  USER_NOT_REGISTERED: "user_not_found",
  PHONE_NOT_FOUND: "",
};

export enum ToastTypesList {
  SUCCESS = "SUCCESS",
  INFO = "INFO",
  SYSTEM = "SYSTEM",
  ERROR = "ERROR",
}

export const promoStatus = {
  AVAILABLE: 1,
  ACTIVE: 2,
  ONHOLD: 3,
  DISABLED: 4,
  EXPIRED: 5,
};

export const genders = {
  M: "Masculino",
  O: "Otro",
  F: "Femenino",
};

export enum TermsOrPrivacy {
  TERMS = "terms",
  PRIVACY = "privacy",
}

export const routePaths = {
  HOME: "home",
  DETAIL: "promo/:promoId",
  PROFILE: "profile",
  SIGNUP: "signup",
  LOGIN: "login",
  OTP: "otp",
  REGISTER: "register",
  TERMS: "terms/:type",
  STORE: "store",
  STORE_DETAILS: "store/details/:id",
  HISTORY: "history",
  MAINTENANCE: 'maintenance',
};

export const localStorageKeyNames = {
  hasTakenLocationTour: 'hasTakenLocationTour',
  appVersion: 'app_version',
  auth: 'auth',
  promo: 'promo',
  location: 'location',
  showNewVersionBanner: 'show_new_version_banner',
  showMaintenanceScreen: 'show_maintenance_screen',
  userRegisterDate: 'user_registration_date',
  age: 'age_custom',
  gender: 'gender_custom',
}

export const COOKIE_POLICY_COOKIE_NAME = 'cookie_policy_version';
export const ACCEPTED_COOKIE_NOT_LOGGED_IN_COOKIE_NAME = 'accepted_cookie_policy_version';
